module.exports = __webpack_public_path__ + "img/quizmayhem_banner.f72c6abb.png";